export default __webpack_public_path__ + "static/media/tomatotimer.98569ce4.jpeg";